<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="Loi sur les transactions commerciales spécifiées" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Nom de la société exploitante</span>
            <span class="text">Xéro Place Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">personne représentative</span>
            <span class="text">Yuki Narita</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Adresse d'enregistrement de la société/adresse du bureau commercial</span>
            <span class="text">330-0854</span>
            <span class="text">Saitama-ken, Saitama-shi, Omiya-ku, Sakuragi-cho 1-195-1</span>
            <span class="text">Omiya Soramichi KOZ 4e étage</span>

          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">numéro de téléphone</span>
            <span class="text">050-1724-5360</span>
            <span class="text">(*Horaires de réception : en semaine de 10h00 à 17h00)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">adresse email</span>
            <span class="text">support@xeroplace.jp</span>
            <span class="text">*Pour toute demande de renseignements, veuillez utiliser le chat sur le site. En principe, nous vous répondrons dans un délai de 2 jours ouvrés.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">prix</span>
            <span class="text">Affichage pour chaque produit</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
        class="shadow-box-title-description"
        title=""
        >
        <div class="text-container left">
            <span class="text">Frais nécessaires autres que le prix du produit</span>
            <span class="text">Les frais liés au matériel d'utilisation des services fournis par notre société, les frais de connexion Internet, les frais de communication par paquets, la taxe à la consommation et les frais de transfert pour le paiement.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Délai de livraison</span>
            <span class="text">Lors de l'acceptation des candidatures</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Quantité vendue</span>
            <span class="text">Il n'y a pas de spécifications spécifiques.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Mode de paiement</span>
            <span class="text">Nous acceptons les cartes de crédit, PayPal et Amazon Pay.</span>
            <span class="text">*Nous ne pouvons pas accepter les annulations pour des raisons de commodité du client après le paiement. Merci pour votre compréhension.</span>
            <span class="text">Si le paiement n’est pas effectué dans les délais, il sera automatiquement annulé.</span>
            <span class="text">Délai de paiement</span>
            <span class="text">Carte de crédit : Basée sur les termes et conditions de la société émettrice de la carte de crédit.</span>
            <span class="text">PayPal : basé sur les conditions de PayPal.</span>
            <span class="text">Amazonpay : basé sur les conditions générales d'Amazonpay.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Politique de retour et délai</span>
            <span class="text">En règle générale, nous n'acceptons ni les retours ni les échanges, mais si nous sommes 100% fautifs, nous répondrons.</span>
            <span class="text">Toutefois, nous ne pouvons pas répondre dans les cas suivants. Merci pour votre compréhension.</span>
            <span class="text">Si l'article est perdu ou endommagé pendant le processus de livraison</span>
            <span class="text">S'il n'y a pas d'enregistrement vidéo d'éléments non ouverts tels que BOX, etc.</span>
            <span class="text">*Nous accordons une attention particulière à l’inspection des produits re-rétrécis.</span>
            <span class="text">Si plus de 10 jours se sont écoulés depuis l'arrivée du produit</span>
            <span class="text">Si vous trouvez des rayures, etc. sur un article d'évaluation tel que PSA, et nous acceptons votre demande d'échange ou de retour pour cette raison.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Permis d'activité d'antiquaire</span>
            <span class="text">Non 431370066203</span>
            <span class="text">Xéro Place Co., Ltd.</span>
            <span class="text">Commission de la sécurité publique de la préfecture de Saitama</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
